const DROPDOWN_PANEL_CONTENT_SELECTOR = ".w-multi-dropdown, .w-select-dropdown";
const MULTI_SELECTOR_CONTENT_SELECTOR = DROPDOWN_PANEL_CONTENT_SELECTOR;
const DROPDOWN_SELECTOR = ".dropdown";
const DROPDOWN_TOGGLE_SELECTOR = ".dropdown-toggle";
const DROPDOWN_LIST_CLASS = "dropdown-list";
const DROPDOWN_MARKER_ATTRIBUTE = "data-multi-selector-dropdown";
const DROPDOWN_STATE_ATTRIBUTE = "data-dropdown-state";
const DROPDOWN_STATE_CLOSED = "closed";
const DROPDOWN_STATE_PINNED = "pinned";
let isInitialized = false;
let dropdownIdCounter = 0;
let observer = null;
function isMultiSelectorDropdown(element) {
    return element instanceof HTMLElement
        && element.matches(DROPDOWN_SELECTOR)
        && element.querySelector(MULTI_SELECTOR_CONTENT_SELECTOR) !== null;
}
function getDropdownFromTarget(target) {
    if (!(target instanceof Element)) {
        return null;
    }
    const dropdown = target.closest(DROPDOWN_SELECTOR);
    return isMultiSelectorDropdown(dropdown) ? dropdown : null;
}
function getDropdownToggle(dropdown) {
    return dropdown.querySelector(DROPDOWN_TOGGLE_SELECTOR);
}
function getDropdownPanel(dropdown) {
    for (const child of Array.from(dropdown.children)) {
        if (child instanceof HTMLElement && child.classList.contains(DROPDOWN_LIST_CLASS)) {
            return child;
        }
    }
    return null;
}
function ensureDropdownPanelId(panel) {
    if (!panel.id) {
        dropdownIdCounter += 1;
        panel.id = `multi-selector-dropdown-${dropdownIdCounter}`;
    }
    return panel.id;
}
function isPinnedOpen(dropdown) {
    return dropdown.getAttribute(DROPDOWN_STATE_ATTRIBUTE) === DROPDOWN_STATE_PINNED;
}
function syncDropdown(dropdown) {
    if (!isMultiSelectorDropdown(dropdown)) {
        return;
    }
    dropdown.setAttribute(DROPDOWN_MARKER_ATTRIBUTE, "true");
    if (!dropdown.hasAttribute(DROPDOWN_STATE_ATTRIBUTE)) {
        dropdown.setAttribute(DROPDOWN_STATE_ATTRIBUTE, DROPDOWN_STATE_CLOSED);
    }
    const toggle = getDropdownToggle(dropdown);
    const panel = getDropdownPanel(dropdown);
    if (!toggle || !panel) {
        return;
    }
    toggle.setAttribute("aria-controls", ensureDropdownPanelId(panel));
    toggle.setAttribute("aria-expanded", isPinnedOpen(dropdown) ? "true" : "false");
}
function syncDropdownTree(root) {
    if (root instanceof HTMLElement && isMultiSelectorDropdown(root)) {
        syncDropdown(root);
    }
    if (!(root instanceof Element) && !(root instanceof Document)) {
        return;
    }
    for (const dropdown of Array.from(root.querySelectorAll(DROPDOWN_SELECTOR))) {
        syncDropdown(dropdown);
    }
}
function setPinnedState(dropdown, isOpen) {
    syncDropdown(dropdown);
    dropdown.setAttribute(DROPDOWN_STATE_ATTRIBUTE, isOpen ? DROPDOWN_STATE_PINNED : DROPDOWN_STATE_CLOSED);
    getDropdownToggle(dropdown)?.setAttribute("aria-expanded", isOpen ? "true" : "false");
}
function closePinnedDropdowns(exceptDropdown) {
    for (const dropdown of Array.from(document.querySelectorAll(`[${DROPDOWN_MARKER_ATTRIBUTE}]`))) {
        if (dropdown === exceptDropdown || !isPinnedOpen(dropdown)) {
            continue;
        }
        setPinnedState(dropdown, false);
    }
}
function onDocumentClick(event) {
    const dropdown = getDropdownFromTarget(event.target);
    if (!dropdown) {
        closePinnedDropdowns();
        return;
    }
    syncDropdown(dropdown);
    const toggle = getDropdownToggle(dropdown);
    if (toggle && event.target instanceof Node && toggle.contains(event.target)) {
        const shouldOpen = !isPinnedOpen(dropdown);
        closePinnedDropdowns(dropdown);
        setPinnedState(dropdown, shouldOpen);
        return;
    }
    closePinnedDropdowns(dropdown);
}
function onDocumentKeydown(event) {
    if (event.key === "Escape") {
        closePinnedDropdowns();
    }
}
function startDropdownObserver() {
    if (observer || !document.body) {
        return;
    }
    observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            for (const node of Array.from(mutation.addedNodes)) {
                if (node instanceof HTMLElement) {
                    syncDropdownTree(node);
                }
            }
        }
    });
    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
}
export function closeDropdownPanel(dropdown) {
    setPinnedState(dropdown, false);
}
export function initDropdown() {
    if (isInitialized) {
        return;
    }
    isInitialized = true;
    syncDropdownTree(document);
    // Capture phase so toggles still work inside modals that call stopPropagation()
    // on content clicks (e.g. question-bank create lightbox).
    document.addEventListener("click", onDocumentClick, true);
    document.addEventListener("keydown", onDocumentKeydown);
    startDropdownObserver();
}
